export function getParameter(parameterName) {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(parameterName);
}
